import { render, staticRenderFns } from "./DirectDeposit.vue?vue&type=template&id=c897daa2&scoped=true&"
import script from "./DirectDeposit.vue?vue&type=script&lang=js&"
export * from "./DirectDeposit.vue?vue&type=script&lang=js&"
import style0 from "./DirectDeposit.vue?vue&type=style&index=0&id=c897daa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c897daa2",
  null
  
)

export default component.exports